import React from 'react';

type Props = { children: React.ReactNode };
type State = { hasError: boolean; error: Error | null };

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary] caught:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='flex flex-col items-center justify-center h-screen gap-4 p-8 text-center'>
          <h1 className='text-2xl font-bold text-red-600'>
            Something went wrong
          </h1>
          <p className='text-gray-600 max-w-md'>
            An unexpected error occurred. Please refresh the page. If the
            problem persists, contact support.
          </p>
          <button
            onClick={() => window.location.reload()}
            className='px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700'
          >
            Refresh page
          </button>
          {import.meta.env.DEV && this.state.error && (
            <pre className='mt-4 text-left text-xs bg-gray-100 p-4 rounded max-w-2xl overflow-auto'>
              {this.state.error.toString()}
            </pre>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}
